export var CARD_ISSUING_ERRORS;
(function (CARD_ISSUING_ERRORS) {
    CARD_ISSUING_ERRORS["EXISTING_PHYSICAL_CARD"] = "EXISTING_PHYSICAL_CARD";
    CARD_ISSUING_ERRORS["BUDGET_MUST_BE_POSITIVE"] = "Total Budget must be greater than $0.00";
    CARD_ISSUING_ERRORS["NO_PHONE_NUMBER"] = "NO_PHONE_NUMBER";
    CARD_ISSUING_ERRORS["INVALID_USER_ADDRESS"] = "INVALID_USER_ADDRESS";
    CARD_ISSUING_ERRORS["CARDHOLDER_STATUS_DEACTIVATED"] = "CARDHOLDER_STATUS_DEACTIVATED";
    CARD_ISSUING_ERRORS["CARDHOLDER_STATUS_PENDING"] = "CARDHOLDER_STATUS_PENDING";
})(CARD_ISSUING_ERRORS || (CARD_ISSUING_ERRORS = {}));
export const VIRTUAL_CARD_ICON = 'img/icons/virtual_card.svg';
export const PHYSICAL_CARD_ICON = 'img/icons/physical_card.svg';
export const BULK_ORDER_PHYSICAL_CARD_ICON = 'img/icons/bulk_order_physical_card.svg';
